import StutterStepModal from './component'

export default StutterStepModal



// WEBPACK FOOTER //
// ./src/components/StutterStepModal/index.js